module.exports = __webpack_public_path__ + "img/rayo-vallecano-logo-icon.d3b1304a.png";